// extracted by mini-css-extract-plugin
export default {"cls1":"Zu4Z7s8VdzL2yHmnFYi4","cls2":"fvGsOKIgoDQQFjInDjut Zu4Z7s8VdzL2yHmnFYi4"};